(function () {
  'use strict';

  function activitySearchResult (cdblMarkedFilter, UserService) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        comment: '=',
        activity: '<',
        task: '=',
        searchInput: '=',
        currentUser: '=',
        goToActivity: '&',
        refactoredMode: '='
      },
      templateUrl: require('../../views/comments/search_result_comment.html'),
      link: function ($scope) {
        $scope.UserService = UserService;

        const parseSearchInput = input => {
          return {
            words: input.split(' ')
          };
        };

        function highlight() {
          const parsedSearchInput = parseSearchInput($scope.searchInput);

          // console.log(parsedSearchInput.words.join('|'));
          // SECURITY (KB-8718): never assign raw comment text to innerHTML - inline handlers
          // (e.g. <img onerror>) execute even on detached elements. Run it through the
          // sanitising markdown filter first; only sanitised HTML may touch innerHTML.
          var commentEl = document.createElement('span');
          // html-sink-ok: output of sanitising cdblMarked filter (KB-8718) (KB-8771)
          commentEl.innerHTML = cdblMarkedFilter($scope.comment.text || '');
          $(commentEl).find('a').attr('target', '_blank');

          $(commentEl).markRegExp(new RegExp(parsedSearchInput.words.join('|'), 'gi'), {
            element: 'span',
            className: 'highlight'
          });

          $scope.comment.textMarked = commentEl.innerHTML;
        }

        $scope.$watch('searchInput', highlight);
      }
    };
  }

  app.directive('activitySearchResult', ['cdblMarkedFilter', 'UserService', activitySearchResult]);
})();
